import React, { useEffect, useState } from "react";
import NewsFullPage from "../components/commons/NewsFullPage";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import axios from "axios";
import { useParams } from "react-router-dom";

const NewsItemLink = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [news, setNews] = useState(null);
    const { link, title } = useParams();

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        const loadNews = async () => {
            const newsData = await axios.get(
                `https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production/links?link=/noticias/${link}/${title}/`,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    crossDomain: true,
                }
            );
            
            setNews(newsData.data[0]);
        };

        loadNews();

        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Notícia</h1>
                {news && <NewsFullPage news={news} isMobile={isMobile} />}
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default NewsItemLink;
